import * as React from "react";
import { Routes, Route } from "react-router-dom";

import { AppProviders } from "./app/AppProviders";
import AuthCheckGate from "./app/AuthCheckGate";
import MainLayout from "./layouts/MainLayout";
import NotFound from "./pages/NotFound";
import AdminDashboard from "./pages/AdminDashboard";
import Donation from "./pages/Donation";
import AddDonation from "./pages/AddDonation";
import DonationDetails from "./pages/DonationDetails";
import AdminUserProfilePage from "./pages/AdminUserProfilePage";
import AdminSpiritualProfilePage from "./pages/AdminSpiritualProfilePage";
import AdminUsersPage from "./pages/AdminUsersPage";
import AdminUserDonationsPage from "./pages/AdminUserDonationsPage";
import AdminUserBulkEditPage from "./pages/AdminUserBulkEditPage";
import AdminEventsPage from "./pages/AdminEventsPage";
import AdminEventParticipantsPage from "./pages/AdminEventParticipantsPage";
import AdminEventCreatePage from "./pages/AdminEventCreatePage";
import AdminEventEditPage from "./pages/AdminEventEditPage";
import AdminAnnouncementsPage from "./pages/AdminAnnouncementsPage";
import AdminAnnouncementCreatePage from "./pages/AdminAnnouncementCreatePage";
import AdminAnnouncementDetailPage from "./pages/AdminAnnouncementDetailPage";
import AdminQuotesPage from "./pages/AdminQuotesPage";
import AdminQuoteCreatePage from "./pages/AdminQuoteCreatePage";
import AdminQuoteDetailPage from "./pages/AdminQuoteDetailPage";
import AdminReadingNotesPage from "./pages/AdminReadingNotesPage";
import AdminReadingNoteCreatePage from "./pages/AdminReadingNoteCreatePage";
import AdminReadingNoteDetailPage from "./pages/AdminReadingNoteDetailPage";
import AdminReadingNoteEditPage from "./pages/AdminReadingNoteEditPage";
import AdminMediaPage from "./pages/AdminMediaPage";
import AdminDarshanPage from "./pages/AdminDarshanPage";
import DarshanGallery from "./pages/DarshanGallery";
import DarshanGalleryDay from "./pages/DarshanGalleryDay";
import GlobalSnackbar from "./components/common/GlobalSnackbar";
import EventPage from "./pages/EventPage";
import Support from "./pages/Support";
import CongregationAdminLayout from "./pages/congregation/CongregationAdminLayout";
import CongregationDashboardPage from "./pages/congregation/CongregationDashboardPage";
import CongregationApplicationsPage from "./pages/congregation/CongregationApplicationsPage";
import CongregationMentorStaffingPage from "./pages/congregation/CongregationMentorStaffingPage";
import CongregationMastersPage from "./pages/congregation/CongregationMastersPage";
import MentorBatchesPage from "./pages/congregation/MentorBatchesPage";
import AdminBooksPage from "./pages/congregation/AdminBooksPage";
import AdminDevoteesPage from "./pages/congregation/AdminDevoteesPage";
import AdminSadhanaPage from "./pages/congregation/AdminSadhanaPage";
import CongregationAttendancePage from "./pages/congregation/CongregationAttendancePage";
import CongregationServicesPage from "./pages/congregation/CongregationServicesPage";
import CongregationServiceTypesPage from "./pages/congregation/CongregationServiceTypesPage";

export default function App() {
  return (
    <AppProviders>
      <AuthCheckGate>
        <Routes>
          <Route element={<MainLayout />}>
            <Route path="/" element={<AdminDashboard />} />
            <Route path="/users" element={<AdminUsersPage />} />
            <Route path="/users/bulk-edit" element={<AdminUserBulkEditPage />} />
            <Route path="/users/:id" element={<AdminUserProfilePage />} />
            <Route path="/users/:id/spiritual" element={<AdminSpiritualProfilePage />} />
            <Route path="/users/:id/donations" element={<AdminUserDonationsPage />} />
            <Route path="/announcements" element={<AdminAnnouncementsPage />} />
            <Route path="/announcements/new" element={<AdminAnnouncementCreatePage />} />
            <Route path="/announcements/:id" element={<AdminAnnouncementDetailPage />} />
            <Route path="/quotes" element={<AdminQuotesPage />} />
            <Route path="/quotes/new" element={<AdminQuoteCreatePage />} />
            <Route path="/quotes/:id" element={<AdminQuoteDetailPage />} />
            <Route path="/darshan" element={<AdminDarshanPage />} />
            <Route path="/darshan-gallery" element={<DarshanGallery />} />
            <Route path="/darshan-gallery/:type" element={<DarshanGalleryDay />} />
            <Route path="/darshan-gallery/:type/:date" element={<DarshanGalleryDay />} />
            <Route path="/articles" element={<AdminReadingNotesPage />} />
            <Route path="/articles/new" element={<AdminReadingNoteCreatePage />} />
            <Route path="/articles/:id" element={<AdminReadingNoteDetailPage />} />
            <Route path="/articles/:id/edit" element={<AdminReadingNoteEditPage />} />
            <Route path="/media" element={<AdminMediaPage />} />
            <Route path="/events" element={<AdminEventsPage />} />
            <Route path="/events/new" element={<AdminEventCreatePage />} />
            <Route path="/events/:eventId/edit" element={<AdminEventEditPage />} />
            <Route path="/events/:eventId/participants" element={<AdminEventParticipantsPage />} />
            <Route path="/events/:id" element={<EventPage />} />
            <Route path="/donations" element={<Donation />} />
            <Route path="/donations/details" element={<DonationDetails />} />
            <Route path="/donate" element={<AddDonation />} />
            <Route path="/support" element={<Support />} />
            <Route path="/congregation" element={<CongregationAdminLayout />}>
              <Route path="dashboard" element={<CongregationDashboardPage />} />
              <Route path="applications" element={<CongregationApplicationsPage />} />
              <Route path="mentors" element={<CongregationMentorStaffingPage />} />
              <Route path="masters" element={<CongregationMastersPage />} />
              <Route path="batches" element={<MentorBatchesPage />} />
              <Route path="books" element={<AdminBooksPage />} />
              <Route path="devotees" element={<AdminDevoteesPage />} />
              <Route path="sadhana" element={<AdminSadhanaPage />} />
              <Route path="attendance" element={<CongregationAttendancePage />} />
              <Route path="services" element={<CongregationServicesPage />} />
              <Route path="service-types" element={<CongregationServiceTypesPage />} />
            </Route>
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
        <GlobalSnackbar />
      </AuthCheckGate>
    </AppProviders>
  );
}
